var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCydeoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_20_21",
    "data-name": "Component 20 \\u2013 21",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.999,
    height: 15.044,
    viewBox: "0 0 75.999 15.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(0 0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M58.31,38.131a3.81,3.81,0,0,0,1.842-.459A4.981,4.981,0,0,0,61.7,36.32l2.394,2.228a7.089,7.089,0,0,1-2.584,2.02,7.611,7.611,0,0,1-3.325.771,8.169,8.169,0,0,1-3.092-.583,7.682,7.682,0,0,1-2.479-1.583A7.38,7.38,0,0,1,50.971,36.8a7.437,7.437,0,0,1,1.652-8.309A7.828,7.828,0,0,1,55.1,26.906a8.076,8.076,0,0,1,3.081-.583,7.893,7.893,0,0,1,3.409.771A6.856,6.856,0,0,1,64.2,29.156l-2.457,2.291A5.077,5.077,0,0,0,60.121,30a4,4,0,0,0-1.938-.489,3.888,3.888,0,0,0-1.61.333,4,4,0,0,0-1.281.906,4.129,4.129,0,0,0-.847,1.375,4.762,4.762,0,0,0-.307,1.718,4.547,4.547,0,0,0,.318,1.707,4.115,4.115,0,0,0,.879,1.364,4.037,4.037,0,0,0,1.324.9A4.207,4.207,0,0,0,58.31,38.131Z",
    transform: "translate(-50.368 -26.315)",
    fill: "#060335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M91.858,41.336V26.312H98.02a7.554,7.554,0,0,1,2.973.591,7.691,7.691,0,0,1,2.421,1.6,7.49,7.49,0,0,1,2.217,5.366,7.268,7.268,0,0,1-.6,2.919,7.45,7.45,0,0,1-1.622,2.382,7.55,7.55,0,0,1-2.421,1.588,7.682,7.682,0,0,1-2.973.579ZM98,29.31H95.465v9.042H98a3.475,3.475,0,0,0,1.526-.345,3.862,3.862,0,0,0,1.245-.946,4.478,4.478,0,0,0,.831-1.425,5.064,5.064,0,0,0,.3-1.759,5.226,5.226,0,0,0-.3-1.793,4.6,4.6,0,0,0-.831-1.448,3.941,3.941,0,0,0-1.245-.969A3.393,3.393,0,0,0,98,29.31Z",
    transform: "translate(-60.638 -26.312)",
    fill: "#060335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M113.749,41.336V26.312h11.438v3.006h-7.719v3.007h5.449v3.01h-5.449v3.019h7.805v2.983Z",
    transform: "translate(-66.057 -26.312)",
    fill: "#060335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M146.358,33.829a7.515,7.515,0,0,1-2.2,5.341,7.534,7.534,0,0,1-2.412,1.593,7.648,7.648,0,0,1-2.99.583,7.728,7.728,0,0,1-3-.583,7.5,7.5,0,0,1-2.421-1.593,7.562,7.562,0,0,1,0-10.682,7.5,7.5,0,0,1,2.421-1.593,7.728,7.728,0,0,1,3-.583,7.648,7.648,0,0,1,2.99.583,7.534,7.534,0,0,1,2.412,1.593,7.512,7.512,0,0,1,2.2,5.341Zm-3.588,0a5.146,5.146,0,0,0-.307-1.789,4.391,4.391,0,0,0-.844-1.431,3.975,3.975,0,0,0-1.284-.943,3.871,3.871,0,0,0-3.2,0,3.971,3.971,0,0,0-1.283.943,4.366,4.366,0,0,0-.844,1.431,5.368,5.368,0,0,0,0,3.579,4.366,4.366,0,0,0,.844,1.431,3.95,3.95,0,0,0,1.283.943,3.871,3.871,0,0,0,3.2,0,3.953,3.953,0,0,0,1.284-.943,4.392,4.392,0,0,0,.844-1.431A5.143,5.143,0,0,0,142.771,33.829Z",
    transform: "translate(-70.359 -26.312)",
    fill: "#060335"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(14.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M80.1,26.3l-3.06,4.624L73.99,26.3H69.659l7.388,11.161L84.434,26.3Z",
    transform: "translate(-69.659 -26.299)",
    fill: "#01c9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1127",
    "data-name": "Rectangle 1127",
    width: 2.941,
    height: 2.994,
    transform: "translate(5.917 12.05)",
    fill: "#01c9ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCydeoLogo);
export default __webpack_public_path__ + "static/media/cydeo-logo.ed3b68e6a8d308e27ec8279d9b9c1a98.svg";
export { ForwardRef as ReactComponent };